import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45c57bc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backswipe-area" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Drop Gem ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [
        _directive_touch,
        _ctx.prevStage,
        "swipe",
        { right: true }
      ]
    ]),
    (_ctx.currentStage > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            id: "icon-left",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevStage && _ctx.prevStage(...args))),
            src: _ctx.arrowLeft
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      name: _ctx.currentStageName,
      onNextStage: _ctx.nextStage,
      onSetReceiverEvent: _ctx.setReceiverId,
      onSetMessageEvent: _ctx.setMessage,
      onSetGemColorEvent: _ctx.setGemColor
    }, null, 8, ["name", "onNextStage", "onSetReceiverEvent", "onSetMessageEvent", "onSetGemColorEvent"]),
    (_ctx.shouldShowNextButton)
      ? (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          class: "form-navigation-button",
          round: "",
          type: "primary",
          onClick: _ctx.nextStage
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.currentStage === _ctx.numStages - 1)
      ? (_openBlock(), _createBlock(_component_van_button, {
          key: 2,
          class: "form-navigation-button",
          round: "",
          type: "primary",
          onClick: _ctx.dropMyGem
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}